import { FC, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSuccessfulUpdateSnackbar, useFailedUpdateSnackbar, LoadingIndicator, ApiError } from "../../../../Components/CoreLib/library";
import { SiteHaulingLineItemForm } from "../../../../Components/Forms/QuoteForm";
import { SiteHaulingLineItemDto } from "../../../../dtos";
import { useLazyGetQuoteByIdQuery, useGetSiteHaulingLineItemByIdQuery, useUpdateSiteHaulingLineItemMutation } from "../../../../store/generated/generatedApi";


export const EditSiteHaulingLineItemView: FC = () => {
    const { quoteId, lineItemId } = useParams();
    const navigate = useNavigate();
    const [getQuote, { data: quote, isLoading: isQuoteLoading }] = useLazyGetQuoteByIdQuery();
    const { data, isLoading, error, refetch } = useGetSiteHaulingLineItemByIdQuery({ id: lineItemId! });
    const [updateSiteHaulingLineItem, { isSuccess, isError, reset }] = useUpdateSiteHaulingLineItemMutation();

    useEffect(() => {
        if (quoteId && !quote) {
            getQuote({ id: quoteId! });
        }
    }, [quote, quoteId, getQuote]);

    useSuccessfulUpdateSnackbar('Haul Rate Line Item', isSuccess, () => {
        if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`);
        } else {
            navigate(`/quotes`);
        }
    });
    useFailedUpdateSnackbar('Haul Rate Line Item', isError, reset);

    const handleSave = (values: SiteHaulingLineItemDto) => {
        updateSiteHaulingLineItem(values);
    };

    const handleCancel = () => {
        if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`)
        } else {
            navigate(`/quotes`);
        }
    };

    if (isLoading || isQuoteLoading) {
        return <LoadingIndicator />;
    }

    if (error) {
        return <ApiError onReloadClick={refetch} />;
    }

    return <SiteHaulingLineItemForm save={handleSave} cancel={handleCancel} initValues={data} quote={quote} />;
};
